'use client';

/* eslint-disable @next/next/no-img-element */
import React, { ReactNode } from 'react';
import { twMerge } from 'utilities/src/twMerge';

import MenuItem from 'ui/src/data/MenuItem';
import Flyout from 'ui/src/components/Flyout_deprecated';
import { type IIconsProps } from 'ui/src/components/Icon';

import HeaderContainer, { type HeaderContainerThemeProps } from './HeaderContainer';
import MobileHeader from '../mobileHeader_deprecated';

import useHeaderThemes from './themes';

type BairesDevHeaderProps = HeaderContainerThemeProps & {
  menuItems?: MenuItem[];
  selectedLabel?: string;
  logoPath: string;
  CtaButton?: JSX.Element; // TODO improve the way buttons are being passed.
  logoSize: {
    width: number;
    height: number;
  };
  superMenu?: boolean;
  mobileMenu?: boolean;
  mobileMenuClasses?: string;
  headerLinkClasses?: string;
  headerLinkChildren?: ReactNode;
  headerLogoUrl?: string;
  headerClasses?: string;
  toggleIconSize?: IIconsProps['size'];
  toggleIconClasses?: string;
  menuItemsClasses?: string;
  menuItemSelectedClasses?: string;
  headerLogoClasses?: string;
};

/** @deprecated use layout/src/components/BairesDevHeader instead */
function BairesDevHeader({
  menuItems,
  selectedLabel = 'Blog',
  logoPath,
  CtaButton,
  logoSize,
  superMenu = false,
  bg,
  size = 'Medium',
  enableHeaderBehavior,
  animatedHeader,
  mobileMenu = true,
  mobileMenuClasses,
  headerLinkClasses = '',
  headerLinkChildren = null,
  headerLogoUrl = process.env.NEXT_PUBLIC_HOSTNAME,
  headerClasses,
  toggleIconSize,
  toggleIconClasses,
  menuItemsClasses,
  menuItemSelectedClasses,
  headerLogoClasses,
}: BairesDevHeaderProps) {
  const { headerLogoLinkClasses, headerNavClasses, headerNavContainerClasses, headerNavContainerThemeClasses } =
    useHeaderThemes({ bg });

  return (
    <HeaderContainer
      bg={bg}
      size={size}
      enableHeaderBehavior={enableHeaderBehavior}
      animatedHeader={animatedHeader}
      classes={headerClasses}
    >
      <div className={headerLinkClasses}>
        <a
          href={`${headerLogoUrl ?? 'https://www.bairesdev.com'}/`}
          className={twMerge(headerLogoLinkClasses, headerLogoClasses)}
        >
          <img
            src={logoPath}
            alt="BairesDev"
            width={logoSize.width}
            height={logoSize.height}
            className="cursor-pointer"
          />
        </a>
        {headerLinkChildren}
      </div>

      <div className={twMerge(headerNavContainerClasses, headerNavContainerThemeClasses)}>
        <nav aria-label="BairesDev main navigation" className={headerNavClasses}>
          {menuItems && (
            <Flyout
              menuItems={menuItems}
              selectedLabel={selectedLabel}
              superMenu={superMenu}
              bg={bg}
              size={size}
              itemClasses={menuItemsClasses}
              selectedItemClasses={menuItemSelectedClasses}
            />
          )}
          {CtaButton}
        </nav>
      </div>

      {mobileMenu && (
        <MobileHeader
          menuItems={menuItems}
          CtaButton={CtaButton}
          mobileMenuClasses={mobileMenuClasses}
          iconSize={toggleIconSize}
          iconClasses={toggleIconClasses}
        />
      )}
    </HeaderContainer>
  );
}

export default BairesDevHeader;
